module.exports = __webpack_public_path__ + "static/media/host-duel.85f55e26.gif";